import React, { useEffect, useState } from "react";
import "./GenreFilter.css";
export default function GenreFilter(props) {
  //constants/variables
  const { selectedGenres, allGenres, onGenreChange } = props;

  const [refresh, setRefresh] = useState(false);
  //states
  const localSelectedLangsAndGenre = JSON.parse(
    localStorage.getItem("selectedLanguagesAndGenresTemp")
  );
  //useEffects

  //functions

  const handleGenreCheck = (e) => {
    const { name, value, checked } = e.target;
    const changeGenre = { name, value, checked };
    onGenreChange(changeGenre);
    setRefresh(!refresh);
    props.scrollOnAction();
  };
  return (
    <div
      className="row m-0 "
      style={{
        overflowY: allGenres.length > 7 ? "scroll" : "hidden",
        height: allGenres.length > 9 ? "20rem" : "200px",
      }}
    >
      <div className="filterContainer">
        {allGenres.map((oneGenre) => (
          <div className="checkBox-container" key={oneGenre}>
            <input
              type="checkbox"
              name="genre"
              value={oneGenre}
              // disabled={!localSelectedLangsAndGenre?.selectedGenre?.filter(e => e === oneGenre).length > 0 }
              checked={selectedGenres.filter((e) => e === oneGenre).length > 0}
              className="form-check-label"
              onChange={(e) => {
                handleGenreCheck(e);
              }}
            />
            <p>{oneGenre}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
